import axios from 'axios';
import Vue from 'vue';
import Cookies from 'js-cookie';
import router from './../router';
import { HG_API_BASE_URL } from '@/config/domainnameconstant';
import { Dialog, Toast } from 'vant';
let vue = new Vue();

// 创建axios实例
const service = axios.create({
  timeout: 2 * 60 * 1000, // 请求超时时间 2min
});

// http request 拦截器
service.interceptors.request.use(
  (config) => {
    config.headers.post['Content-Type'] = 'application/json';
    config.baseURL = HG_API_BASE_URL;

    const token = Cookies.get('token');
    if (token) {
      config.headers['Authorization'] = token.startsWith('Bearer ')
        ? token
        : 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    if (error.message.includes('timeout')) {
      // Toast('请求服务器超时')
      return Promise.reject(error);
    }
    Promise.reject(error);
  }
);

/**
 * 添加响应拦截器，统一处理服务器响应和异常
 */
service.interceptors.response.use(
  (res) => {
    if (res.status < 200 || res.status > 299) {
      toast(res.error || '似乎有些问题');

      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      if (res.data.code === 401) {
        handle401();
      }
      if (res.data.code === 503) {
        toast(res.error || '似乎有些问题');
      }

      return res;
    }
  },
  (error) => {
    let err = '请求出现错误，请稍后再试';
    if (error.response) {
      if (error.response.data.code == 401) {
        handle401();
      } else if (error.response.data.code == 503) {
        err = '站点更新中，请稍后访问~';
      }
      err = error.response.data.msg;
    }
    toast(err);
    return Promise.reject(error);
  }
);

const handle401 = () => {
  Dialog.alert({
    title: '提示',
    message: '登录超时，请重新登录',
    confirmButtonText: '去登录',
  }).then(() => {
    //跳转的同时删除token
    Cookies.remove('token');
    if (vue.$getIsApp()) {
      linkToApp();
    } else {
      router.push({
        path: '/login',
        query: { callbackUrl: window.location.href },
      });
    }
  });
};

const toast = (msg) => {
  Toast(msg);
};
const linkToApp = () => {
  vue.$callApp('Android', 'AppLogin', localStorage.isLogin);
  vue.$callApp('iOS', 'AppLoginMethod', localStorage.isLogin);
};

export default service;
